import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	boardHeading: {
		id: 'work-management-board.board-heading',
		defaultMessage: 'Board',
		description: 'Heading of the JWM Board view',
	},
});
